import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { LiveInterviewType } from 'types'
import LiveRoom from 'components/live-room'
import FetchWithSpinner from 'components/fetch-with-spinner'
import { languages } from 'i18n'
import { fetchLiveInterview } from 'interview/actions/live'
import { setLanguage } from 'actions'

interface LiveInterviewProps {
  params: {
    liveInterviewId: string
    roomCode: string
  }
  liveInterview: LiveInterviewType
  dispatch: any
}

const mapStateToProps = (state: any) => ({
  liveInterview: state.interview.liveInterview,
})

function LiveInterview({
  params,
  liveInterview,
  dispatch,
}: LiveInterviewProps) {
  useEffect(() => {
    const { participant } = liveInterview
    if (
      participant &&
      participant.language &&
      participant.language in languages
    ) {
      dispatch(setLanguage(participant.language))
    } else {
      // Fallback to english
      dispatch(setLanguage('en'))
    }
  }, [liveInterview ])
  return (
    <FetchWithSpinner
      action={() => fetchLiveInterview(params.liveInterviewId, params.roomCode)}
    >
      <LiveRoom
        liveInterview={liveInterview}
        roomUrl={liveInterview.roomUrl}
        participant={liveInterview.participant}
      />
    </FetchWithSpinner>
  )
}

export default connect(mapStateToProps)(LiveInterview)
